const config = require('../config/config');
const SuccessHandler = require("fuzzy-reaction/lib/utils/SuccessHandler");
const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const api = FuzzyReaction.Utils.ApiService;
const ActionTypes = FuzzyReaction.Constants.ActionTypes;
const AppDispatcher = FuzzyReaction.Dispatcher;

module.exports = {
    baseUrl: config.base.apiVersionedUrl + 'subscriptions/',

    reverify: function (userId) {
        "use strict";
        api.post(this.baseUrl + 'reverify', {'user_id': userId}, {}, function (data) {
            AppDispatcher.dispatch({
                type: ActionTypes.REVERIFIED_SUBSCRIPTION,
                data: data.data[0]
            });
            SuccessHandler.success('The subscription was re-verified.');
        });
    }
};
